<template>
  <div class="the-navbar__user-meta flex items-center">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ displayName }}</p>
      <small>{{ businessName }}</small>
    </div>


    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
    >

      <div class="con-img ml-3">
        <vs-avatar v-if="user" badge :text="displayName" color="success" :src="image" />
        <vs-avatar v-else badge color="danger"/>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li @click="$router.push('/profile')" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon
              icon="UserIcon"
              svgClasses="w-4 h-4"
            />
            <span class="ml-2">Profile</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon
              icon="LogOutIcon"
              svgClasses="w-4 h-4"
            />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    image () {
      if (this.user.profile_image) return this.user.profile_image
      return null
    },
    displayName () {
      if (this.user) {
        if (this.user.user_detail && this.user.user_detail.full_name) return this.user.user_detail.full_name
        return this.user.email
      }
      return 'Anonymous User'
    },
    businessName () {
      if (this.user && this.user.business) return this.user.business.name
      return 'Unauthorized'
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    },
  }
}
</script>
